import React from 'react';
import { Box, Text, Flex, Button, Collapse, Heading } from '@chakra-ui/react';
import { QuestionnaireResultsResult, QuestionnaireQuestionAnswer } from 'src/@types';
import { goToUrl } from 'src/utils';
import { FormattedMessage } from 'react-intl';

interface SuccessProps {
  result: QuestionnaireResultsResult | undefined;
  answersGiven: QuestionnaireQuestionAnswer[];
  activeStep: 1 | 2;
  setActiveStep: React.Dispatch<React.SetStateAction<1 | 2>>;
  isOpen: boolean;
  onToggle: () => void;
}

const QuestionnaireResult: React.FC<SuccessProps> = ({
  result,
  answersGiven,
  activeStep,
  setActiveStep,
  isOpen,
  onToggle
}) => {
  return (
    <>
      {activeStep === 2 && (
        <Box>
          <Box backgroundColor={`gray.200`} p={8} mb={8}>
            <Heading as={`h3`} variant={`h3`} mb={4}>
              {result?.title}
            </Heading>
            <Text mb={4}>{result?.text}</Text>
            <Flex>
              <Button type="button" onClick={() => setActiveStep(1)} colorScheme="orange">
                <FormattedMessage
                  id={'questionnaire.result.back'}
                  defaultMessage={`Terug naar de test`}
                />
              </Button>

              {result?.ctaUrl && result?.ctaText && (
                <Button
                  onClick={() => goToUrl(result?.ctaUrl, 'current')}
                  ml={4}
                  type="button"
                  colorScheme="blue">
                  {result?.ctaText}
                </Button>
              )}
            </Flex>
          </Box>

          <Box p={8}>
            <Button type="button" onClick={onToggle} colorScheme="blue" variant={`outline`} mb={10}>
              {!isOpen ? (
                <FormattedMessage
                  id={'questionnaire.result.viewExplanation'}
                  defaultMessage={`Bekijk de toelichting`}
                />
              ) : (
                <FormattedMessage
                  id={'questionnaire.result.closeExplanation'}
                  defaultMessage={`Verberg toelichting`}
                />
              )}
            </Button>

            <Collapse in={isOpen}>
              {answersGiven?.map((answer) => (
                <Box key={answer.id} mb={12}>
                  <Text as={`h3`} fontSize={`lg`} mb={2}>
                    {answer.question}
                  </Text>
                  <Text mb={2}>Jouw antwoord: {answer.answer}</Text>
                  {answer.explanation && (
                    <Text backgroundColor={`gray.200`} p={4}>
                      {answer.explanation}
                    </Text>
                  )}
                </Box>
              ))}
            </Collapse>
          </Box>
        </Box>
      )}
    </>
  );
};

export default QuestionnaireResult;
